import { MusicClefBassIcon } from './MusicClefBassIcon';

/**
 * author: Haley Halcyon
 * id 279EAB4C-7D62-4C41-A67F-2928723476DA
 * name music-clef-bass
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-clef-bass.svg
 * tags
 * - Music 
 */
export const MusicFClefIcon = MusicClefBassIcon;
export default MusicFClefIcon